// Must stay first — strips hub tokens from the URL before analytics loads.
import './captureUrlSecrets.js'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { ensureAnonymousAuth } from '@/firebase'
import authHub from '@/services/authHub'
import revenueCat from '@/services/revenueCat'

// Boot sequence:
// 1. Handle any auth hub return token (SSO sign-in)
// 2. Ensure anonymous auth on DrawLab's own Firebase project (for RTDB access)
// 3. Render the app
async function boot() {
  // Step 1: if we're returning from the auth hub with a token, exchange it
  // for a signed-in session. This is a no-op if there's no token.
  try {
    await authHub.handleAuthReturn();
  } catch (err) {
    console.warn('[boot] Auth hub return handling failed:', err);
    // Continue anyway — the user can still use DrawLab anonymously
  }

  // Step 2: ensure anonymous auth — needed for RTDB access regardless of
  // whether the user has signed in via the hub
  const uid = await ensureAnonymousAuth();

  // Step 3: initialise RevenueCat (no-op on web). Uses Firebase UID as
  // appUserID so purchases are tied to the user's DDD account and sync
  // across devices. Non-blocking — failure here shouldn't stop the app.
  revenueCat.initialise(uid).catch((err) => {
    console.warn('[boot] RevenueCat initialisation failed:', err);
  });

  // Step 4: render
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <App authUid={uid} />
    </StrictMode>,
  );
}

boot().catch((err) => {
  console.error('Failed to initialise DrawLab:', err);
  document.getElementById('root').innerHTML =
    '<div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;color:#64748b;">' +
    '<p>Unable to connect. Please refresh the page.</p></div>';
});
